import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { normalizeBirthNumber } from "web_myplann/Shared/Utils/birthNumber";
import { requiredBirthNumber } from "web_myplann/Shared/Validation/requiredBirthNumber";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

const getShortTextShape = (t: TranslateFunction) =>
	z
		.string()
		.trim()
		.max(
			ValidationLimits.TextLength.Short,
			t(Resources.Portfolio.AddShared.Validations.maxLength, {
				max: ValidationLimits.TextLength.Short,
			}),
		);

export const getCoDebtorShape = (t: TranslateFunction) =>
	z.object({
		id: z.number().nullable(),
		firstname: getShortTextShape(t),
		lastname: getShortTextShape(t),
		identification: getShortTextShape(t),
	});

const getRequiredNameShape = (t: TranslateFunction) =>
	getShortTextShape(t).min(
		1,
		t(Resources.Portfolio.AddShared.Validations.required),
	);

export const getCoDebtorDrawerShape = (
	t: TranslateFunction,
	otherIdentifications: string[],
) =>
	getCoDebtorShape(t).extend({
		firstname: getRequiredNameShape(t),
		lastname: getRequiredNameShape(t),
		identification: requiredBirthNumber(
			t(Resources.Portfolio.AddShared.Validations.required),
			t(Resources.Portfolio.AddShared.Validations.birthNumberFormat),
		).refine(
			(identification) =>
				!otherIdentifications.some(
					(otherIdentification) =>
						normalizeBirthNumber(otherIdentification) ===
						normalizeBirthNumber(identification),
				),
			t(Resources.Portfolio.CoDebtors.duplicateIdentification),
		),
	});

export const getCoDebtorsShape = (t: TranslateFunction) =>
	z.array(getCoDebtorShape(t));

export type CoDebtorFormValue = {
	id: number | null;
	firstname: string;
	lastname: string;
	identification: string;
};

export const EMPTY_CO_DEBTOR: CoDebtorFormValue = {
	id: null,
	firstname: "",
	lastname: "",
	identification: "",
};
